var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7148 0H1.71484C0.871094 0 0.214844 0.6875 0.214844 1.5V10.5C0.214844 11.3438 0.871094 12 1.71484 12H14.7148C15.5273 12 16.2148 11.3438 16.2148 10.5V1.5C16.2148 0.6875 15.5273 0 14.7148 0ZM1.71484 1H14.7148C14.9648 1 15.2148 1.25 15.2148 1.5V2.8125C14.5273 3.375 13.5273 4.1875 10.4961 6.59375C9.96484 7.03125 8.93359 8.03125 8.21484 8C7.46484 8.03125 6.43359 7.03125 5.90234 6.59375C2.87109 4.1875 1.87109 3.375 1.21484 2.8125V1.5C1.21484 1.25 1.43359 1 1.71484 1ZM14.7148 11H1.71484C1.43359 11 1.21484 10.7812 1.21484 10.5V4.09375C1.90234 4.6875 3.02734 5.59375 5.27734 7.375C5.93359 7.90625 7.05859 9.03125 8.21484 9C9.33984 9.03125 10.4648 7.90625 11.1211 7.375C13.3711 5.59375 14.4961 4.6875 15.2148 4.09375V10.5C15.2148 10.7812 14.9648 11 14.7148 11Z",
    fill: "#F6F6F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.23bc471ca4c9ed6f60a435528caf5e7e.svg";
export { ForwardRef as ReactComponent };